// Live ambient background: drifting aurora blobs + highway light streaks.
// Sits fixed behind all content, pointer-events-none, GPU-friendly.

const STREAKS = [
  { top: "18%", w: "26rem", dur: "7s", delay: "0s", c: "var(--xd-streak-blue)" },
  { top: "42%", w: "34rem", dur: "9s", delay: "2.5s", c: "var(--xd-streak-gold)" },
  { top: "63%", w: "22rem", dur: "6s", delay: "1.2s", c: "var(--xd-streak-blue)" },
  { top: "82%", w: "30rem", dur: "10s", delay: "4s", c: "var(--xd-streak-gold)" },
];

export function AnimatedBackground() {
  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 -z-10 overflow-hidden pointer-events-none"
      style={{
        background: "#0B1220",
        "--xd-streak-blue": "rgba(46,107,255,0.55)",
        "--xd-streak-gold": "rgba(245,179,1,0.45)",
      }}
    >
      {/* Aurora blobs */}
      <div
        className="aurora-blob absolute -top-40 -left-32 w-[46rem] h-[46rem] rounded-full blur-[120px] opacity-25"
        style={{ background: "radial-gradient(circle at center, #2E6BFF 0%, transparent 70%)" }}
      />
      <div
        className="aurora-blob absolute top-1/3 -right-40 w-[40rem] h-[40rem] rounded-full blur-[130px] opacity-20"
        style={{ background: "radial-gradient(circle at center, #F5B301 0%, transparent 70%)", animationDelay: "6s", animationDuration: "32s" }}
      />
      <div
        className="aurora-blob absolute bottom-[-12rem] left-1/3 w-[38rem] h-[38rem] rounded-full blur-[120px] opacity-[0.16]"
        style={{ background: "radial-gradient(circle at center, #2E6BFF 0%, transparent 70%)", animationDelay: "3s", animationDuration: "28s" }}
      />

      {/* Moving highway light streaks */}
      {STREAKS.map((s, i) => (
        <span
          key={i}
          className="animate-streak absolute h-px"
          style={{
            top: s.top,
            width: s.w,
            left: 0,
            animationDuration: s.dur,
            animationDelay: s.delay,
            background: `linear-gradient(90deg, transparent, ${s.c}, transparent)`,
            boxShadow: `0 0 12px ${s.c}`,
          }}
        />
      ))}

      {/* Subtle drifting grid */}
      <div
        className="animate-grid absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "linear-gradient(#4A6BFF 1px, transparent 1px), linear-gradient(90deg, #4A6BFF 1px, transparent 1px)",
          backgroundSize: "80px 80px",
          maskImage: "radial-gradient(ellipse 100% 60% at 50% 0%, #000 40%, transparent 100%)",
          WebkitMaskImage: "radial-gradient(ellipse 100% 60% at 50% 0%, #000 40%, transparent 100%)",
        }}
      />

      {/* Vignette to keep content readable */}
      <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at center, transparent 30%, rgba(11,18,32,0.55) 100%)" }} />
    </div>
  );
}
